module.exports = __webpack_public_path__ + "img/skilled-trades-logo.49395d92.jpg";